module.exports = __webpack_public_path__ + "img/6.3b1f2c13.jpg";